import { Pipe, PipeTransform } from '@angular/core';
import { TabType } from 'src/models/general/tabs/tab.type.enum';

@Pipe({
    name: 'pageTitle',
    standalone: false
})
export class PageTitlePipe implements PipeTransform {

	transform(value: TabType, singleEntityName: string, multipleEntitiesName: string): string {
		if (!singleEntityName || !multipleEntitiesName) {
			throw Error(`No entityStrings provided`);
		}
		switch (value) {
			case TabType.list:
				return `Alle ${multipleEntitiesName}`;
			case TabType.details:
				return 'Details';
			case TabType.create:
				return `${singleEntityName} erstellen`;
			default:
				throw Error(`Unknown TabType: ${value}`);
		}
	}

}
